import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepMemberPersonalInfoComponent } from './components/steps/StepMemberPersonalInfoComponent';
import { StepDocUploadComponent } from './components/steps/StepDocUploadComponent';

import {
  setOptions,
  overrideComponent,
  MemberPersonalInfoViewModel,
  setViewModel
} from '@sheerid/jslib';

import {
  ruleOptInValidator,
  projectNameValidator,
  osiLicenseValidator,
  projectDescriptionValidator,
  publicProjectValidator
} from './validators/customFieldValidators';


const defaultViewModel: MemberPersonalInfoViewModel = {
  birthDate: '',
  countryChoice: undefined,
  email: '',
  firstName: '',
  lastName: '',
  localeChoice: {
    value: 'en-US',
    label: ''
  },
  memberId: '',
  organization: {
    id: 0,
    name: 'GitLab'
  },
  phoneNumber: '',
  metadata: {
    ruleOptIn: false,
    projectName: '',
    projectDescription: '',
    projectDescription2: '',
    publicProject: '',
    OSIlicense: '',
    verifyProject: '',
  },
};

setOptions(defaultOptions);
googleTagManagerHook();

ruleOptInValidator();
projectNameValidator();
projectDescriptionValidator();
publicProjectValidator();
osiLicenseValidator();

setViewModel(defaultViewModel);

// @ts-ignore
overrideComponent('StepMemberPersonalInfoComponent', StepMemberPersonalInfoComponent)
// @ts-ignore
overrideComponent('StepDocUploadComponent', StepDocUploadComponent)


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
